import * as React from 'react';
import { SVGProps } from 'react';

const IconMLSPSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 2H9v3h2L8.273 15H5v3h18v-3h-3.273L17 5h2V2Zm-2.273 13h-5.454l1.909-7h1.636l1.91 7Z"
    />
    <path d="M6 22.085V26h3v-3.396c.304-.045.602-.126.884-.241l1.517-.621a1.31 1.31 0 0 1 .918-.023l1.862.654c.966.34 2.072.278 2.973-.165l.744-.365c.32-.158.715-.17 1.049-.033l.053.021V26h3v-3.326a3.94 3.94 0 0 0 .779-.11L26 21.465V19l-3.848 1.175a1.311 1.311 0 0 1-.802-.057l-1.427-.585c-1.001-.41-2.188-.372-3.148.1l-.743.365c-.3.147-.67.168-.991.055l-1.863-.654a3.932 3.932 0 0 0-2.753.066l-1.516.622a1.312 1.312 0 0 1-.871.037l-2.582-.793a3.934 3.934 0 0 0-2.613.112L2 19.898v2.465l1.819-.644c.271-.11.587-.124.87-.037L6 22.085Z" />
  </svg>
);
export default IconMLSPSizeL;
